<!-- eslint-disable indent -->
<!-- eslint-disable indent -->
<!-- eslint-disable semi -->
<template>
  <div class="config-box">
    <div id="canvas_background" style="width:0;height:0;overflow:hidden">
    </div>
    <div class="clearfix" style="padding: 10px">
      <!-- <div v-if="isDesktop()">
        <span class="pull-left">未成人退款资料提交</span>
        <div class="pull-right">
          <el-button type="text" @click="handleDialog('')">提交流程</el-button>
          <el-button type="text" @click="handleDialog('faq')">
            申请FAQ
          </el-button>
          <el-button type="text" @click="handleDownload"
            >下载退款确认书</el-button
          >
        </div>
      </div> -->
      <div v-if="isDesktop()" class="pull-left">未成人退款资料提交</div>
      <div v-else style="text-align: center">未成人退款资料提交</div>
    </div>
    <div class="config-box-form">
      <el-form
        :model="configForm"
        :rules="configRules"
        ref="configForm"
        label-width="210px"
        :label-position="isDesktop() ? 'right' : 'top'"
      >
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix" style="position: relative">
            <div class="text-center">
              <span>监护人信息</span>
              <el-button style="padding: 8px 12px;margin-left: auto;" type="primary" @click="previewDialog = true">查看模板</el-button>
            </div>
            <p style="font-size: 12px; color: red">提示：根据模板规范填写内容，可更快通过审核</p>
          </div>
          <el-form-item label="游戏名称" prop="gameName">
            <el-input
              v-model="configForm.gameName"
              placeholder="请填写充值游戏的名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="游戏角色ID" prop="gameRoleId">
            <el-input
              v-model="configForm.gameRoleId"
              placeholder="请填写游戏角色ID。例：123456"
            ></el-input>
            <p class="tip_text">* 如不清楚或账号已被封禁在此处说明原因。例：不清楚、已封禁。</p>
          </el-form-item>
          <el-form-item label="监护人姓名" prop="parentName">
            <el-input
              v-model="configForm.parentName"
              placeholder="请填写监护人姓名。例：李某某"
            ></el-input>
          </el-form-item>
          <el-form-item label="监护人手机号" prop="parentMobile">
            <el-input
              v-model="configForm.parentMobile"
              placeholder="请填写监护人手机号"
            ></el-input>
            <p class="tip_text"
              >* 后续工作人员会通过手机号添加微信，请注意查看微信是否开启手机号添加权限。</p
            >
          </el-form-item>
          <el-form-item label="可联系的微信号" prop="wxNo">
            <el-input
              v-model="configForm.wxNo"
              placeholder="请填写可联系的微信号"
            ></el-input>
          </el-form-item>
          <el-form-item label="本人与孩子关系" prop="relation">
            <el-input
              v-model="configForm.relation"
              placeholder="请填写本人与孩子关系。例：父子/父女/母女/母子"
            ></el-input>
            <p class="tip_text"
              >* 必须是法定监护人</p
            >
          </el-form-item>
          <el-form-item label="监护人身份证正反面截图" prop="parentCards">
            <el-upload
              :name="'filecontent'"
              :action="uploadUrl"
              :data="uploadParams"
              :show-file-list="false"
              :before-upload="handlePicCompression"
              :on-success="
                (res) => {
                  this.uploadSuccess(res, 'parentCards', 'custom', 0);
                }
              "
              :with-credentials="true"
              :accept="getAcceptType()"
              style="display: inline-block;"
            >
              <div class="img-box pull-left" style="cursor: pointer;">
                <img
                  v-if="configForm.parentCards[0]"
                  class="el-icon-error img-close"
                  src="https://wxmini-resource.hortorgames.com/background-image/Lark20201113-144853.png"
                  alt=""
                  style="width: 20px; height: 20px"
                  @click.stop="deleteImg(0, 'parentCards', 'custom')"
                />
                <img
                  alt="身份证正面"
                  :src="configForm.parentCards[0] || `https://wxmini-resource.hortorgames.com/background-image/%E8%BA%AB%E4%BB%BD%E8%AF%81%E6%AD%A3%E9%9D%A2-1681885201.jpeg`"
                  style="
                    width: 120px;
                    height: 100px;
                    margin-left: 8px;
                    border-radius: 6px;
                  "
                />
              </div>
            </el-upload>
            <el-upload
              :name="'filecontent'"
              :action="uploadUrl"
              :show-file-list="false"
              :data="uploadParams"
              :before-upload="handlePicCompression"
              :on-success="
                (res) => {
                  this.uploadSuccess(res, 'parentCards', 'custom', 1);
                }
              "
              :with-credentials="true"
              :accept="getAcceptType()"
              style="display: inline-block"
            >
              <div class="img-box pull-left" style="cursor: pointer;">
                <img
                  v-if="configForm.parentCards[1]"
                  class="el-icon-error img-close"
                  src="https://wxmini-resource.hortorgames.com/background-image/Lark20201113-144853.png"
                  alt=""
                  style="width: 20px; height: 20px"
                  @click.stop="deleteImg(1, 'parentCards', 'custom')"
                />
                <img
                  alt="身份证反面"
                  :src="configForm.parentCards[1] || `https://wxmini-resource.hortorgames.com/background-image/%E8%BA%AB%E4%BB%BD%E8%AF%81%E5%8F%8D%E9%9D%A2-1681885457.jpeg`"
                  style="
                    width: 120px;
                    height: 100px;
                    margin-left: 8px;
                    border-radius: 6px;
                  "
                />
              </div>

            </el-upload>
            <p class="tip_text"
              >* 请提供监护人身份证正反面截图，您可以在身份证、户口本的照片上打上水印。关键信息不可遮挡。</p
            >
          </el-form-item>
          <el-form-item label="监护人户口本 截图" prop="parentBook">
            <el-upload
              :name="'filecontent'"
              :action="uploadUrl"
              :data="uploadParams"
              :show-file-list="false"
              :before-upload="handlePicCompression"
              :on-success="
                (res) => {
                  this.uploadSuccess(res, 'parentBook', 'string');
                }
              "
              :with-credentials="true"
              :accept="getAcceptType()"
            >
              <div v-if="configForm.parentBook" class="img-box pull-left">
                <img
                  class="el-icon-error img-close"
                  src="https://wxmini-resource.hortorgames.com/background-image/Lark20201113-144853.png"
                  alt=""
                  style="width: 20px; height: 20px"
                  @click.stop="deleteImg('', 'parentBook', 'string')"
                />
                <img
                  alt="暂无图片"
                  v-imgLazy="configForm.parentBook"
                  style="width: 100px; height: 100px; border-radius: 6px"
                />
              </div>
              <div class="img-box pull-right" @click.stop="example.src = `https://wxmini-resource.hortorgames.com/background-image/%E7%9B%91%E6%8A%A4%E4%BA%BA%E6%88%B7%E5%8F%A3%E6%9C%AC-1681885071.png`; example.viewBigImage = true">
                <img
                  alt="户口本例图"
                  src="https://wxmini-resource.hortorgames.com/background-image/%E7%9B%91%E6%8A%A4%E4%BA%BA%E6%88%B7%E5%8F%A3%E6%9C%AC-1681885071.png"
                  style="width: 100px; height: 100px; border-radius: 6px;margin-left: 8px;"
                />
              </div>
              <i v-if="!configForm.parentBook" class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <p class="tip_text"
              >* 请注意提供监护人户口本详情页面截图（带有身份证号那页）</p
            >
          </el-form-item>
        </el-card>
        <el-card class="box-card" shadow="never" style="margin: 20px 0">
          <div slot="header" class="clearfix">
            <span>孩子信息</span>
          </div>
          <el-form-item label="孩子姓名" prop="childName">
            <el-input
              v-model="configForm.childName"
              placeholder="请填写孩子姓名。例：李某某"
            ></el-input>
          </el-form-item>
          <el-form-item label="孩子年龄" prop="childAge">
            <el-input
              type="number"
              v-model.number="configForm.childAge"
              placeholder="请填写孩子年龄。需注意必须是阿拉伯数字。例：8"
            ></el-input>
          </el-form-item>
          <el-form-item label="孩子的充值金额(元)" prop="chargeMoney">
            <el-input
              type="number"
              v-model.number="configForm.chargeMoney"
              placeholder="请填写孩子的充值金额(元)"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="充值记录截图(带微信订单号)" prop="chargeRecords">
            <el-upload
              :name="'filecontent'"
              :action="uploadUrl"
              :data="uploadParams"
              :show-file-list="false"
              :before-upload="handlePicCompression"
              :on-success="
                (res) => {
                  this.uploadSuccess(res, 'chargeRecords', 'array');
                }
              "
              :with-credentials="true"
              :accept="getAcceptType()"
            >
              <div
                v-for="(item, index) in configForm.chargeRecords || []"
                :key="index"
                class="img-box pull-left"
              >
                <img
                  class="el-icon-error img-close"
                  src="https://wxmini-resource.hortorgames.com/background-image/Lark20201113-144853.png"
                  alt=""
                  style="width: 20px; height: 20px"
                  @click.stop="deleteImg(index, 'chargeRecords', 'array')"
                />
                <img
                  alt="暂无图片"
                  v-imgLazy="item"
                  style="
                    width: 100px;
                    height: 100px;
                    margin-right: 8px;
                    border-radius: 6px;
                  "
                />
              </div>
              <div class="img-box pull-right" @click.stop="example.src=`https://wxmini-resource.hortorgames.com/background-image/%E5%85%85%E5%80%BC%E8%AE%B0%E5%BD%95-1698917206.jpg`; example.viewBigImage = true">
                <img
                  alt="充值例图"
                  src="https://wxmini-resource.hortorgames.com/background-image/%E5%85%85%E5%80%BC%E8%AE%B0%E5%BD%95-1698917206.jpg"
                  style="width: 100px; height: 100px; border-radius: 6px;margin-left: 8px;"
                />
              </div>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <p class="tip_text"
              >* 至少提供3张订单详情截图，如订单少于三张，请根据实际情况提供。</p
            >
          </el-form-item>
          <el-form-item label="孩子户口本截图" prop="childBook">
            <el-upload
              :name="'filecontent'"
              :action="uploadUrl"
              :data="uploadParams"
              :show-file-list="false"
              :before-upload="handlePicCompression"
              :on-success="
                (res) => {
                  this.uploadSuccess(res, 'childBook', 'string');
                }
              "
              :with-credentials="true"
              :accept="getAcceptType()"
            >
              <div v-if="configForm.childBook" class="img-box pull-left">
                <img
                  class="el-icon-error img-close"
                  src="https://wxmini-resource.hortorgames.com/background-image/Lark20201113-144853.png"
                  alt=""
                  style="width: 20px; height: 20px"
                  @click.stop="deleteImg('', 'childBook', 'string')"
                />
                <img
                  alt="暂无图片"
                  v-imgLazy="configForm.childBook"
                  style="width: 100px; height: 100px; border-radius: 6px"
                />
              </div>
              <div class="img-box pull-right" @click.stop="example.src=`https://wxmini-resource.hortorgames.com/background-image/%E5%AD%A9%E5%AD%90%E6%88%B7%E5%8F%A3%E6%9C%AC-1681885070.jpg`; example.viewBigImage = true">
                <img
                  alt="孩子户口本"
                  src="https://wxmini-resource.hortorgames.com/background-image/%E5%AD%A9%E5%AD%90%E6%88%B7%E5%8F%A3%E6%9C%AC-1681885070.jpg"
                  style="width: 100px; height: 100px; border-radius: 6px;margin-left: 8px;"
                />
              </div>
              <i v-if="!configForm.childBook" class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <p class="tip_text"
              >* 请您提供孩子户口本详情页面截图（带有身份证号那页）。材料信息需能证明亲属关系，如户口本无法证明，请您在下方追加出生证明。</p
            >
          </el-form-item>
          <el-form-item label="出生证明">
            <el-upload
              :name="'filecontent'"
              :action="uploadUrl"
              :data="uploadParams"
              :show-file-list="false"
              :before-upload="handlePicCompression"
              :on-success="
                (res) => {
                  this.uploadSuccess(res, 'otherConfigImg', 'array');
                }
              "
              :with-credentials="true"
              :accept="getAcceptType()"
            >
              <div
                v-for="(item, index) in configForm.otherConfigImg || []"
                :key="index"
                class="img-box pull-left"
              >
                <img
                  class="el-icon-error img-close"
                  src="https://wxmini-resource.hortorgames.com/background-image/Lark20201113-144853.png"
                  alt=""
                  style="width: 20px; height: 20px"
                  @click.stop="deleteImg(index, 'otherConfigImg', 'array')"
                />
                <img
                  alt="暂无图片"
                  v-imgLazy="item"
                  style="
                    width: 100px;
                    height: 100px;
                    margin-right: 8px;
                    border-radius: 6px;
                  "
                />
              </div>
              <div class="img-box pull-right" @click.stop="example.src=`https://wxmini-resource.hortorgames.com/background-image/%E5%87%BA%E7%94%9F%E8%AF%81%E6%98%8E-1681885071.jpg`; example.viewBigImage = true">
                <img
                  alt="出生证明"
                  src="https://wxmini-resource.hortorgames.com/background-image/%E5%87%BA%E7%94%9F%E8%AF%81%E6%98%8E-1681885071.jpg"
                  style="width: 100px; height: 100px; border-radius: 6px;margin-left: 8px;"
                />
              </div>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-card>
        <el-card class="box-card" shadow="never" style="margin: 20px 0">
          <div slot="header" class="clearfix">
            <span>其他信息</span>
          </div>
          <span
            style="color: #409eff; font-size: 12px"
            :style="{ 'margin-left': isDesktop() ? '210px' : '' }"
            >* 
            客服工作时间为周一至周日，上午10:00至晚上19:30，可在此期间进行视频沟通，过程中监护人与孩子必须同时在场</span
          >
          <el-form-item label="监护人备注">
            <el-input
              type="textarea"
              :rows="5"
              v-model="configForm.remark"
              placeholder="请填写监护人备注"
            ></el-input>
          </el-form-item>
        </el-card>
      </el-form>
    </div>
    <div class="submit-footer">
      <el-button type="primary" @click="handleSubmit">提交</el-button>
    </div>
    <el-dialog
      :title="dialogType == 'faq' ? '退款FAQ' : '退款流程'"
      :visible.sync="isDialog"
      width="60%"
    >
      <div v-if="dialogType == 'faq'">
        <p>Q：充值记录哪里找？被删除了怎么办？</p>
        <p>
          A：充值记录需要到您进入微信钱包 - 点击账单 - 点开相关的充值 -
          进行截图，如已经删除需要您联系微信客服查询一下相关的商户单号。
        </p>
        <p>Q：相关证明目前因特殊原因无法提供，孩子误充值退款有没有时间限制？</p>
        <p>
          A：只要判定确实是孩子误充值导致的，我们一定会全额退款，没有时间限制，您可以在证件齐全了之后再来提交。
        </p>
        <p>Q：自己与孩子不是直系监护人关系怎么办？</p>
        <p>A：需要让孩子直系监护人与我们取得联系。</p>
        <p>Q：退款的款项去哪里领？</p>
        <p>A：退款款项会通过原充值渠道进行返还</p>
        <p>Q：提交的信息是否会被泄露？</p>
        <p>
          A：游戏平台不会泄露您任何的隐私信息，您可以在身份证、户口本的照片上打上水印。如：仅供xx游戏退款所用（关键信息处不可有遮挡）
        </p>
        <p>Q：信息提交后需要等多久？</p>
        <p>
          A：工作人员预计会在7个工作日内以短信形式通知您材料是否通过审核，材料审核通过后，工作人员将与您和孩子约定时间进行视频沟通，最后会综合评定是否通过。
        </p>
        注：退款成功后，游戏账号的所有数据将被永久冻结，之后将无法登陆游戏且无法解冻，且每名用户仅支持一次退款申请。超出一次平台将不予受理。
      </div>
      <img
        v-else
        style="width: 100%"
        src="https://wxmini-resource.hortorgames.com/background-image/Lark20201112-145110.png"
        alt=""
      />
    </el-dialog>
    <el-dialog
     title="预览模板"
     :visible.sync="previewDialog"
     :width="isDesktop() ? '50%' : '88%'"
    >
      <el-image
        style="width: 100%"
        src="https://wxmini-resource.hortorgames.com/background-image/longpic-1681981300.jpeg"
        alt=""
      />
    </el-dialog>
    <el-dialog
     title="查看大图"
     :visible.sync="example.viewBigImage"
     :width="isDesktop() ? '50%' : '88%'"
    >
      <el-image
        style="width: 100%"
        :src="example.src"
        alt=""
      />
    </el-dialog>
  </div>
</template>

<script>
import { isDesktop, validateMobile, isWX } from '@utils/lib';
import imgLazy from '@directive/ImgLazy.js';
import $api from '@api/index';

export default {
	directives: { imgLazy },

	data() {
		const validatePhone = (rule, value, callback) => {
			if (!value) callback(new Error('请填写手机号'));
			else if (!validateMobile(value))
				callback(new Error('请填写正确格式的手机号!'));
			else callback();
		};
		const validateParentCards = (rule, value, callback) => {
			if ((value || []).length < 2)
				callback(new Error('请提交监护人证件正反面照片'));
			else callback();
		};

		return {
			isDialog: false,
			uploadParams: {
				isOpenCheck: true, 
				needEncryption: true
			} ,
			dialogType: '',
			isDesktop,
			previewDialog: false,
			// srcList: ['https://wxmini-resource.hortorgames.com/background-image/moban-1677479142.jpeg'],
			configForm: {
				parentCards: [],
				refundedConfigImg: [],
				gameRoleId: '',
				chargeRecords: [],
				otherConfigImg: [],
			},
			configRules: {
				gameName: [
					{
						required: true,
						message: '请填写游戏名称',
						trigger: 'blur',
					},
				],
				gameRoleId: [
					{
						required: true,
						message: '请输入游戏角色ID',
						trigger: 'blur',
					},
				],
				parentName: [
					{
						required: true,
						message: '请填写监护人姓名',
						trigger: 'blur',
					},
				],
				parentMobile: [
					{
						required: true,
						message: '请填写联系电话',
						trigger: 'blur',
					},
					{ validator: validatePhone, trigger: 'blur' },
				],
				relation: [
					{
						required: true,
						message: '请填写本人与孩子的关系',
						trigger: 'blur',
					},
				],
				parentCards: [
					{
						required: true,
						message: '请上传监护人身份证正方面截图',
						trigger: 'blur',
					},
					{ validator: validateParentCards, trigger: 'blur' },
				],
				parentBook: [
					{
						required: true,
						message: '请上传监护人户口本截图',
						trigger: 'blur',
					},
				],
				childName: [
					{
						required: true,
						message: '请填写孩子姓名',
						trigger: 'blur',
					},
				],
				chargeMoney: [
					{
						required: true,
						message: '请填写孩子充值金额',
						trigger: 'blur',
					},
				],
				chargeRecords: [
					{
						required: true,
						message: '请上传充值记录截图(带微信订单号)',
						trigger: 'blur',
					},
				],
				childBook: [
					{
						required: true,
						message: '请上传孩子户口本截图',
						trigger: 'blur',
					},
				],
				refundedConfigImg: [
					{
						required: true,
						message: '请上传退款确认书照片',
						trigger: 'blur',
					},
				],
				wxNo: [
					{
						required: true,
						message: '请填写可联系的微信号',
						trigger: 'blur',
					},
				],
				bookingTime: [
					{
						required: true,
						message: '请选择预约微信视频时间',
						trigger: 'blur',
					},
				],
				childAge: [
					{
						required: true,
						message: '请填写年龄',
						trigger: 'blur',
					},
				],
			},
			// uploadUrl: `${window.HOST}/mini_background/v1/file/upload`,
			uploadUrl: `${window.UploadHOST}/api/v1/image/attach/upload`,
			example: {
				viewBigImage: false,
				src: '',
			},
		};
	},

	methods: {
		uploadSuccess(res, key, dataType, index) {
			if (res.meta.errCode !== 0 || !res.data || !res.data.length) {
				this.$message.error('上传图片失败: ' + res.meta.errMsg);
				return;
			}
			if (dataType == 'array') {
				const keyValues = this.configForm[key];

				this.$set(this.configForm, key, [...keyValues, res.data]);
			}
			if (dataType == 'custom') {
				const [a,b] = this.configForm[key] || [];
				const data = index == 0 ? [res.data, b] : [a, res.data];
				this.$set(this.configForm, key, data);
			}
			if (dataType == 'string') {
				this.$set(this.configForm, key, res.data);
			}
		},
		deleteImg(data, key, dataType) {
			let filterValues = '';

			if (dataType == 'array') {
				let tempArr = [];
				const keyValues = this.configForm[key] || [];

				keyValues.forEach((item, index) => {
					if (index != data) {
						tempArr.push(item);
					}
				});
				filterValues = tempArr;
			}

			if (dataType == 'custom') {
				const [a,b] = this.configForm[key] || [];
				const arr = data == 0 ? ['', b] : [a, ''];
				filterValues = arr;
			}

			this.$set(this.configForm, key, filterValues);
		},
		async submit(data) {
			const params = JSON.parse(JSON.stringify(data));
			params.bookingTime = parseInt(params.bookingTime / 1000, 10) || 57599;
			params.bookingEndTime = parseInt(new Date().getTime() / 1000, 10);
			const res = await $api.info_api.toSubmit(params);

			if (res.meta.errCode !== 0) {
				this.$message.error(`提交失败, ${res.meta.errMsg}`);
				return;
			}
			this.$router.push({ name: 'result' });
		},

		handlePicCompression(file) {
			return new Promise((resolve, reject) => {
				if(file.size > 2097152){ //2MB
					let reader = new FileReader();
					  let img = new Image(); 
					reader.addEventListener('load',function(){
						let tempSrc = reader.result;
						img.src = tempSrc;
						let target = document.querySelector('#canvas_background');
						target.appendChild(img);
						img.addEventListener('load',function(){
							let canvas = document.createElement('canvas');
							let context = canvas.getContext('2d');
							const originalWidth = img.width;
							const originalHeight = img.height;
							const ratio = +(originalWidth/originalHeight).toFixed(2);
							const targetWidth = 800;
							const targetHeight = Math.round(targetWidth / ratio);
							canvas.width = targetWidth;
							canvas.height = targetHeight;
							context.clearRect(0,0,targetWidth,targetHeight);
							context.drawImage(img,0,0,targetWidth,targetHeight);
							const type = 'image/png';
							const imgName = file.name.slice(0,file.name.lastIndexOf('.'))+'.png';
							canvas.toBlob(function(blob){
								img.remove();
								if(!blob || blob.size<100) reject();
								const f = new File([blob], imgName ,{type}); 
								if(f) {
									file = f;
									resolve(f);
								} else reject();
							},type);
						});
						
					},false);
					 reader.readAsDataURL(file);
				} else{
					resolve(file);
				}
			});
		},

		handleSubmit() {
			this.$refs['configForm'].validate((valid) => {
				if (!valid) {
					return;
				}
				this.submit(this.configForm);
			});
		},
		handleDialog(type) {
			this.dialogType = type;
			this.isDialog = true;
		},
		handleDownload() {
			const url =
        'https://gc-img.oss-cn-qingdao.aliyuncs.com/%E9%80%80%E6%AC%BE%E7%A1%AE%E8%AE%A4%E4%B9%A6.docx';
			window.open(url);
		},
		getAcceptType() {
			return isWX() ? '' : '.jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PBG,.GIF';
		},
	},
};
</script>

<style scoped>
.config-box-form {
  background: #f4f4f4;
  padding: 12px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

::v-deep .el-upload {
  cursor: none;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  cursor: pointer;
}

.avatar {
  max-width: 350px;
  max-height: 120px;
  display: block;
}

.img-box {
  position: relative;
  display: inline-block;
}

.img-close {
  position: absolute;
  top: 2px;
  right: 10px;
  font-size: 20px;
  color: #dcdfe6;
  cursor: pointer;
}

.submit-footer {
  text-align: center;
  padding: 10px;
}

.tip_text {
  font-size: 12px;
  color: rgb(64, 158, 255);
  line-height: 24px;
  margin-bottom: 0;
}

.text-center {
  display: flex;
  align-items: center;
}

::v-deep .el-card__header {
  padding: 18px 20px 0px 20px;
}
</style>

